// See docs/ai/websocket-events.md → "Transition state model".
import type { ConnectionLossReason } from '@/app/state/connectionLossReason';

export interface SocketState {
  isConnected: boolean;
  inTransition: boolean;
  transitionReason: ConnectionLossReason | null;
  bootId: number | null;
}

let value: SocketState = { isConnected: false, inTransition: false, transitionReason: null, bootId: null };
const listeners = new Set<() => void>();

export const getSocket = () => value;

export const setSocket = (patch: Partial<SocketState>) => {
  const next = { ...value, ...patch };
  if (
    next.isConnected === value.isConnected &&
    next.inTransition === value.inTransition &&
    next.transitionReason === value.transitionReason &&
    next.bootId === value.bootId
  )
    return;
  value = next;
  for (const listener of listeners) listener();
};

export const subscribeSocket = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
